var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:"canvas",attrs:{"width":_vm.width,"height":_vm.height,"id":_vm.chartId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }